export function mailAttentionReasons(facts, now = new Date()) {
    if (facts.status === 'Closed')
        return [];
    const reasons = [];
    if (facts.status === 'New' && !facts.assigned_user_id && !facts.assigned_name)
        reasons.push('New and unassigned');
    if (facts.response_due_at) {
        const due = facts.response_due_at instanceof Date ? facts.response_due_at.getTime() : Date.parse(facts.response_due_at);
        if (Number.isFinite(due) && due < now.getTime())
            reasons.push('Recorded response deadline passed');
    }
    if (/\burgent\b/i.test((facts.title ?? '').replace(/\b(?:not|non)[\s-]+urgent\b/gi, '')) && ['Low', 'Normal'].includes(facts.priority ?? ''))
        reasons.push('Urgent wording conflicts with recorded priority');
    if ((facts.proposal_count ?? 0) > 0)
        reasons.push('Classification suggestion needs review');
    if ((facts.draft_count ?? 0) > 0)
        reasons.push('Draft awaiting review');
    if (facts.status === 'Failed')
        reasons.push('Conversation is marked failed');
    if (facts.requires_attention && reasons.length === 0)
        reasons.push('Attention is flagged on this conversation');
    return reasons;
}
//# sourceMappingURL=mail-attention.js.map